import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { GA_CONFIG_ID, initGa } from './ga';
import { useConfiguration } from "./api/configuration";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

function AppAnalytics() {
  const { data: config } = useConfiguration();
  if (config?.flags.EnableAnalytics) {
    initGa();
    return <script async src={`https://www.googletagmanager.com/gtag/js?id=${GA_CONFIG_ID}`}></script>
  }

  return <></>;
}


root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <AppAnalytics />
      <App />
    </BrowserRouter>
  </QueryClientProvider>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
